import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { site } from '@/mocks/site';

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-auto bg-secondary-950 text-secondary-100">
      <div className="mx-auto max-w-content px-4 py-12 md:px-6 md:py-16">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-heading text-lg font-black text-background-50">
                镜
              </span>
              <span className="font-heading text-lg font-bold text-background-50">{site.name}</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-secondary-200">{site.intro}</p>
            <a
              href={`mailto:${site.email}`}
              className="mt-5 inline-flex items-center gap-2 font-label text-sm text-accent-300 transition-colors hover:text-accent-200"
            >
              <i className="ri-mail-line text-base" />
              {site.email}
            </a>
          </div>

          <div className="lg:col-span-3">
            <h3 className="font-heading text-sm font-bold text-background-50">主题分类</h3>
            <ul className="mt-4 space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="font-label text-sm text-secondary-200 transition-colors hover:text-background-50"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h3 className="font-heading text-sm font-bold text-background-50">网站导航</h3>
            <ul className="mt-4 space-y-2.5">
              {[
                { name: '内幕观察', path: '/insight' },
                { name: '常见问题', path: '/faq' },
                { name: '关于我们', path: '/about' },
                { name: '联系我们', path: '/contact' },
              ].map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className="font-label text-sm text-secondary-200 transition-colors hover:text-background-50"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h3 className="font-heading text-sm font-bold text-background-50">内容原则</h3>
            <ul className="mt-4 space-y-2.5 font-label text-sm text-secondary-200">
              <li>公开信息优先</li>
              <li>隐私脱敏处理</li>
              <li>保留当事方回应</li>
              <li>持续跟进更新</li>
            </ul>
          </div>
        </div>

        <div className="mt-10 border-t border-secondary-800 pt-6 md:mt-12">
          <p className="text-xs leading-relaxed text-secondary-300">
            {site.name}为职场信息整理平台，所有内容基于公开资料与自愿投稿，旨在帮助职场人了解信息，不构成法律意见。
            如内容与事实不符，欢迎通过联系页面提交说明，我们将核实后更正。
          </p>
          <div className="mt-5 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
            <p className="font-label text-xs text-secondary-300">
              © {year} {site.name} · {site.tagline}
            </p>
            <p className="font-label text-xs text-secondary-400">
              本站内容以简体中文提供 · 面向职场人的信息参考
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}